export const handleErrors = (error, self, errorFields) => {
    if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        Object.keys(errors).forEach(key => {
            if (key in errorFields) {
                errorFields[key] = errors[key][0] ?? '';
            }
        });
    } else {
        self.$notify({
            type: 'error',
            message: error.response?.data?.message || trans('general.defaults.unknown_error')
        });
    }
}
